(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kabluchka-editorial-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kabluchka-search-canvas')) {
    customElements.define('kabluchka-search-canvas', class KabluchkaSearchCanvas extends HTMLElement {
      connectedCallback() {
        this.openers = Array.from(document.querySelectorAll(`[aria-controls="${this.id}"]`));
        this.modalRoot = this.closest('.shopify-section.ke-site-header-section') || this;
        this.siteHeader = this.modalRoot.querySelector('.ke-site-header');
        this.closeButton = this.querySelector('[data-ke-search-canvas-close]');
        this.panelButtons = Array.from(this.querySelectorAll('[data-ke-search-canvas-target]'));
        this.handleEscape = this.handleEscape.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handlePanelChange = this.handlePanelChange.bind(this);
        this.syncHeaderHeight = this.syncHeaderHeight.bind(this);

        this.openers.forEach((opener) => opener.addEventListener('click', this.handleOpen));
        this.closeButton?.addEventListener('click', this.handleClose);
        this.panelButtons.forEach((button) => button.addEventListener('click', this.handlePanelChange));
      }

      disconnectedCallback() {
        this.openers?.forEach((opener) => opener.removeEventListener('click', this.handleOpen));
        this.closeButton?.removeEventListener('click', this.handleClose);
        this.panelButtons?.forEach((button) => button.removeEventListener('click', this.handlePanelChange));
        document.removeEventListener('keydown', this.handleEscape);
        window.removeEventListener('resize', this.syncHeaderHeight);
      }

      handleOpen(event) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        event.preventDefault();
        if (!this.hidden) {
          if (event.detail === 0) {
            this.closeButton?.focus({ preventScroll: true });
          } else {
            event.currentTarget.blur();
          }
          return;
        }

        const mobileMenu = event.currentTarget.closest('details');
        this.returnFocus = mobileMenu?.querySelector('summary') || event.currentTarget;
        if (mobileMenu) mobileMenu.removeAttribute('open');

        this.hidden = false;
        this.setAttribute('aria-hidden', 'false');
        this.modalRoot.setAttribute('role', 'dialog');
        this.modalRoot.setAttribute('aria-modal', 'true');
        this.modalRoot.setAttribute('aria-label', this.dataset.keSearchCanvasDialogLabel || '');
        this.openers.forEach((opener) => opener.setAttribute('aria-expanded', 'true'));
        document.documentElement.classList.add('ke-search-canvas-lock');
        document.body.classList.add('ke-search-canvas-lock');
        document.addEventListener('keydown', this.handleEscape);
        window.addEventListener('resize', this.syncHeaderHeight, { passive: true });
        this.syncHeaderHeight();
        this.showPanel('root');

        if (typeof trapFocus === 'function' && this.closeButton) trapFocus(this.modalRoot, this.closeButton);
      }

      handleClose() {
        this.hidden = true;
        this.setAttribute('aria-hidden', 'true');
        this.modalRoot.removeAttribute('role');
        this.modalRoot.removeAttribute('aria-modal');
        this.modalRoot.removeAttribute('aria-label');
        this.openers.forEach((opener) => opener.setAttribute('aria-expanded', 'false'));
        document.documentElement.classList.remove('ke-search-canvas-lock');
        document.body.classList.remove('ke-search-canvas-lock');
        document.removeEventListener('keydown', this.handleEscape);
        window.removeEventListener('resize', this.syncHeaderHeight);

        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(this.returnFocus);
        } else {
          this.returnFocus?.focus();
        }
      }

      handleEscape(event) {
        if (event.key === 'Escape') this.handleClose();
      }

      handlePanelChange(event) {
        this.showPanel(event.currentTarget.dataset.keSearchCanvasTarget);
      }

      syncHeaderHeight() {
        const headerHeight = Math.ceil(this.siteHeader?.getBoundingClientRect().height || 0);
        if (headerHeight > 0) this.style.setProperty('--ke-search-canvas-header-height', `${headerHeight}px`);
      }

      showPanel(name) {
        const panels = Array.from(this.querySelectorAll('[data-ke-search-panel]'));
        const activePanel = panels.find((panel) => panel.dataset.keSearchPanel === name);
        if (!activePanel) return;

        panels.forEach((panel) => { panel.hidden = panel !== activePanel; });
        requestAnimationFrame(() => activePanel.querySelector('[data-ke-search-canvas-heading]')?.focus());
      }
    });
  }

  if (!window.__kabluchkaEditorialMobileMenu) {
    window.__kabluchkaEditorialMobileMenu = true;
    const menuSelector = '.ke-site-header__menu';
    const menuDuration = 240;

    const closeMenu = (menu, returnFocus = false) => {
      if (!menu) return;

      window.clearTimeout(menu.__keCloseTimer);
      menu.classList.remove('is-open');
      menu.querySelector('summary')?.setAttribute('aria-expanded', 'false');

      if (!menu.open) {
        menu.classList.remove('is-closing');
        return;
      }

      menu.classList.add('is-closing');
      const finish = () => {
        menu.open = false;
        menu.classList.remove('is-closing');
        if (returnFocus) menu.querySelector('summary')?.focus();
      };

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finish();
      } else {
        menu.__keCloseTimer = window.setTimeout(finish, menuDuration);
      }
    };

    const closeAllMenus = (exception = null) => {
      document.querySelectorAll(menuSelector).forEach((menu) => {
        if (menu !== exception) closeMenu(menu);
      });
    };

    const openMenu = (menu) => {
      if (!menu) return;

      closeAllMenus(menu);
      window.clearTimeout(menu.__keCloseTimer);
      menu.classList.add('is-enhanced');
      menu.classList.remove('is-closing');
      menu.open = true;
      menu.querySelector('summary')?.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => requestAnimationFrame(() => menu.classList.add('is-open')));
    };

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('.ke-site-header__menu-toggle');
      if (toggle) {
        const menu = toggle.closest(menuSelector);
        event.preventDefault();
        if (menu?.open && menu.classList.contains('is-open')) {
          closeMenu(menu);
        } else {
          openMenu(menu);
        }
        return;
      }

      const menuLink = event.target.closest('.ke-site-header__mobile-nav a');
      if (menuLink) {
        closeMenu(menuLink.closest(menuSelector));
        return;
      }

      document.querySelectorAll(`${menuSelector}[open]`).forEach((menu) => {
        if (!menu.contains(event.target)) closeMenu(menu);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll(`${menuSelector}[open]`).forEach((menu) => closeMenu(menu, true));
    });

    window.addEventListener('scroll', () => closeAllMenus(), { passive: true });
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 1200) closeAllMenus();
    }, { passive: true });
  }

  } catch(e) { console.error(e); }
})();
})();
